<template>
  <table class="mailTable" cellspacing="0" cellpadding="0">
    <tr v-for="(o, k, i) in columns" :key="i">
      <td class="column">{{ o.title }}</td>
      <td v-if="columnsTable.indexOf(k) < 0">{{ o.value }}</td>
      <td v-else class="table-col">
        <a-table
          size="middle"
          bordered
          :columns="columnsCol[k]"
          :data-source="o.value"
          rowKey="id"
          :pagination="false"
        >
        </a-table>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  props: {
    columns: {
      type: Object,
      default: {},
    },
    columnsTable: {
      type: Array,
      default: [],
    },
    columnsCol: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style lang="less" scoped>
.mailTable {
  width: 100%;
  border-top: 1px solid #e6eaee;
  border-left: 1px solid #e6eaee;
}
.mailTable tr td {
  width: 200px;
  height: 48px;
  line-height: 48px;
  box-sizing: border-box;
  padding: 0 6px;
  border-bottom: 1px solid #e6eaee;
  border-right: 1px solid #e6eaee;
}
.mailTable tr td.column {
  background-color: #fafafa;
  color: #393c3e;
  width: 30%;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
.mailTable tr td.table-col {
    padding: 12px 16px;
}
</style>
